document.addEventListener("DOMContentLoaded", () => {
  gsap.registerPlugin(ScrollTrigger);

  const sections = document.querySelectorAll("[data-image-text-percentage]");

  sections.forEach((section) => {
    const steps = section.querySelectorAll("[data-image-text-percentage-step]");
    const percentageFilled = section.querySelectorAll(
      "[data-text-percentage-filled]"
    );

    ScrollTrigger.create({
      trigger: section,
      start: "top center",
      once: true,
      onEnter: () => {
        setTimeout(() => {
          percentageFilled.forEach((bar) => {
            bar.classList.add("animate");
          });
        }, 800);
      },
    });
  });
});
